import React from 'react';
import { t } from 'i18next';
import { getStatsIcon } from '../../../../../shared/utils/utils';
import { Tooltip } from 'primereact/tooltip';

interface TrendTagProps {
  trendValue: number | string;
  suffix: string;
  tooltipId?: string;
  size?: 'SM' | 'MD';
}

export const TrendTag: React.FC<TrendTagProps> = ({
  trendValue,
  suffix,
  size = 'MD',
  tooltipId = 'tooltip',
}) => {
  return (
    <div id={`trend-${tooltipId}`} className={`tag tag--stats tag--${size.toLowerCase()}`}>
      <span className={getStatsIcon(trendValue.toString())} />
      <span className="tag__value">
        {isNaN(Number(trendValue)) ? t(`${trendValue}`).toLowerCase() : trendValue + suffix}
      </span>
      {size === 'SM' && (
        <Tooltip
          target={`#trend-${tooltipId}`}
          content={isNaN(Number(trendValue)) ? t(`${trendValue}`) : trendValue + suffix}
          className="tooltip--top"
          position="top"
          showDelay={5}
        />
      )}
    </div>
  );
};
